import Http from '../../../http';
import { startLoadingList, stopLoadingList } from '../../../common/hoc/withLoaingList';
import { getActiveUserIdAndType } from '../../../common/hoc/withActiveUserIdAndType';

export const withOwner = fn => (...data) => (dispatch, getState) => {
  const state = getState();
  const { activeId, activeType } = getActiveUserIdAndType(state);
  const args = [activeId, activeType].concat(data);

  return fn(...args);
};

export const withLoadingListActions = fn => (...data) => (dispatch) => {
  dispatch(startLoadingList());
  return dispatch(withOwner(fn)(...data))
    .then((res) => {
      dispatch(stopLoadingList());
      return res;
    })
    .catch((error) => {
      dispatch(stopLoadingList());
      return error;
    });
};

export const locateDuplicates = (ownerId, ownerType, customerId) => {
  let url = `/${ownerType}/${ownerId}/customer/duplicates`;
  if (customerId) {
    url = `${url}/${customerId}`;
  }

  return Http.get(url);
};

export const fetchDuplicatesForCustomer = (ownerId, ownerType, customerId, customerIds) => (
  Http.get(`/${ownerType}/${ownerId}/customer/${customerId}/merge`, { customerIds })
);

export const mergeDuplicates = (ownerId, ownerType, customerId, customerIds, data) => {
  const params = customerIds.reduce(
    (memo, id) => (memo ? `${memo}&customerIds[]=${id}` : `customerIds[]=${id}`),
    ''
  );
  const url = `/${ownerType}/${ownerId}/customer/${customerId}/merge?${params}`;
  return Http.post(url, data);
};

export const removeFromDuplicateList = (ownerId, ownerType, customerId) =>
  Http.delete(`/${ownerType}/${ownerId}/customer/duplicates/${customerId}`);
